import request from '@/axios'

export function  calenderCreateNote (payload, customer_id) {
  return request({
    url: `V1/schedule/note/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  calenderNoteList (payload, customer_id) {
  return request({
    url: `V1/schedule/note/list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  fetchResheduleLog (customer_id, payload) {
  return request({
    url: `V1/schedule/reschedule/logs/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  fetchResheduleSlot (customer_id, payload) {
  return request({
    url: `V1/schedule/reschedule/available/slots/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  markAttendence (customer_id, payload) {
  return request({
    url: `V1/schedule/attendance/mark/student/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  confirmRescheduleApi (customer_id, payload) {
  return request({
    url: `V1/schedule/reschedule/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  markAttendenceTeacher (customer_id, payload) {
  return request({
    url: `V1/schedule/attendance/mark/teacher/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  fetchDateRange (customer_id, payload) {
  return request({
    url: `V1/schedule/course/date_range/${customer_id}`,
    method: 'POST',
    data:payload
  })
}